<template>
    <div>
        <!-- 顶部 tab：分享活动列表 / 分享活动创建审核 / 分享活动编辑审核 -->
        <div class="page-tabs-box">
            <el-tabs v-model="activeName" @tab-click="tabChange">
                <el-tab-pane label="分享活动列表" name="list"></el-tab-pane>
                <el-tab-pane label="分享活动创建审核" name="createAudit"></el-tab-pane>
                <el-tab-pane label="分享活动编辑审核" name="editAudit"></el-tab-pane>
            </el-tabs>
        </div>
        <!-- tab1：分享活动列表 -->
        <template v-if="activeName == 'list'">
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="10" :lg="10" :xl="6">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="活动标题" :value="1"></el-option>
                            <el-option label="活动ID" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
               <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                   <el-select v-model="params.status" placeholder="请选择" size="small">
                       <el-option label="不限制活动状态" :value="-1"></el-option>
                       <el-option label="仅看未开始的" :value="0"></el-option>
                       <el-option label="仅看进行中的" :value="1"></el-option>
                       <el-option label="仅看已结束的" :value="2"></el-option>
                   </el-select>
               </el-col>
               <!-- 活动来源筛选：管理后台/经营平台 -->
               <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                   <el-select v-model="params.activitySource" placeholder="请选择" size="small">
                       <el-option label="不限制活动来源" :value="-1"></el-option>
                       <el-option label="仅看管理后台创建的" :value="1"></el-option>
                       <el-option label="仅看经营平台创建的" :value="2"></el-option>
                   </el-select>
               </el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/share/activity/create')" type="primary" icon="el-icon-plus" @click="add"
                size="small">新增分享活动</el-button>
            <el-button v-if="$utils.have('/share/activity/export')" type="primary" icon="el-icon-download"
                @click="download" size="small" :loading="downLoading">导出分享活动</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="title" label="标题" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis" :href="scope.row.viewUrl" target="_blank">{{ scope.row.title
                            }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="是否已完成发奖" min-width="120">
                    <div slot="header">
                        <span>是否已完成发奖</span>
                        <el-popover
                            placement="top"
                            title="说明"
                            width="380"
                            trigger="hover">
                            <span slot="reference" class="el-icon-question"></span>
                            <div>
                                <div class="MT10">
                                    <p class="color-success">是：</p>
                                    <p class="MT10">活动结束后，对于没中奖的用户，会提示末中奖</p>
                                </div>
                                <div class="MT20">
                                    <p class="color-danger">否：</p>
                                    <p class="MT10">活动结束后，对于没中奖的用户，会提示等待中奖结果</p>
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <template slot-scope="{row} = scope">
                        <el-switch
                            v-if="$utils.have('/share/activity/updateAwardFlag')"
                            v-model="row.isEndAward"
                            :active-value="1"
                            :inactive-value="0"
                            active-text="是"
                            inactive-text="否"
                            @change="updateAwardFlag(row)">   
                        </el-switch>
                        <div v-else>
                            <span v-if="row.isEndAward == 1" class="color-success">是</span>
                            <span v-else>否</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="活动有效时间" min-width="170">
                    <template slot-scope="{row} = scope">
                        <p>起：{{ row.startTimeStr }}</p>
                        <p>止：{{ row.endTimeStr }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="活动展示时间" min-width="170">
                    <template slot-scope="{row} = scope">
                        <p>起：{{ row.onTimeStr }}</p>
                        <p>止：{{ row.offTimeStr }}</p>
                    </template>
                </el-table-column>               
                <el-table-column prop="joinCount" label="参与人数"></el-table-column>
                <el-table-column label="UV" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>秀动：{{ row.totalUv }}</p>
                        <p>百度：{{ row.totalBdUv }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="PV" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>秀动：{{ row.totalPv }}</p>
                        <p>百度：{{ row.totalBdPv }}</p>
                    </template>
                </el-table-column>
				 <el-table-column label="活动状态" prop="statusView"></el-table-column>
                <el-table-column label="注册转化" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>注册人数：{{ row.totalRegisterCount }}</p>
                        <p>转化率：{{ row.userCr }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="下单转化" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>下单人数：{{ row.totalOrderUserCount }}</p>
                        <p>转化率：{{ row.orderCr }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="销售转化" min-width="120">
                    <template slot-scope="{row} = scope">
                        <p>订单数：{{ row.totalOrderCount }}</p>
                        <p>销售额：{{ row.totalSaleAmount }}</p>
                    </template>
                </el-table-column>

                <!-- </el-table-column> -->
                <el-table-column prop="trackPrefix" label="跟踪参数前缀" min-width="160"></el-table-column>
                <!-- 来源：管理后台/经营平台 -->
                <el-table-column prop="sourceView" label="来源" min-width="90"></el-table-column>
                <el-table-column label="创建" min-width="230">
                    <template slot-scope="{row} = scope">
                        <!-- 经营平台创建的活动展示经营平台创建人/提交审核时间，无值回退管理后台字段 -->
                        <p>创建时间：{{ row.createTimeView || row.createTime }}</p>
                        <p>创建人：{{ row.creatorNameView || row.createUserName }}</p>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="260">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/share/activity/update')" type="text" size="small"
                            @click="edit(scope.row.id)">编辑</el-button>
                        <el-button v-if="$utils.have('/share/activity/delete')" type="text" size="small"
                            @click="del(scope.row.id)">删除</el-button>
                        <el-button type="text" size="small" @click="view(scope.row)">二维码</el-button>
                        <el-button v-if="$utils.have('/shareActivity/joinedUser/list')" type="text" size="small"
                            @click="user(scope.row.id)">参与用户</el-button>
                        <el-button v-if="$utils.have('/share/activity/prize/list')" type="text" size="small"
                            @click="$router.push(`/promotion/shareActivity/award/list?shareActivityId=${scope.row.id}&time=${scope.row.endTime}`)">奖品管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        </template>
        <!-- tab2：分享活动创建审核（auditType 1） -->
        <!-- key 必加：两个审核 tab 是相同标签的组件，无 key 时 Vue 复用实例导致切换不发请求、数据不刷新 -->
        <audit-list v-else-if="activeName == 'createAudit'" key="createAudit" :audit-type="1" tab-name="createAudit"></audit-list>
        <!-- tab3：分享活动编辑审核（auditType 2） -->
        <audit-list v-else key="editAudit" :audit-type="2" tab-name="editAudit"></audit-list>
        <CodeView ref="codeView"></CodeView>
    </div>
</template>
<script>
import { downloadFileTmp } from '@/assets/js/commonApi.js';
import CodeView from '@/components/CodeView';
import AuditList from './auditList.vue';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: '',
	status:-1,
	activitySource: -1
};
export default {
    components: { CodeView, AuditList },
    data() {
        // 仅当 URL query 的 tab 属于 tab1（list 或无）时才从 query 恢复 tab1 查询参数，避免审核 tab 的分页参数污染
        const isTab1Query = !this.$route.query.tab || this.$route.query.tab == 'list';
        return {
            // tab 选中项：list 分享活动列表 / createAudit 创建审核 / editAudit 编辑审核
            activeName: ['list', 'createAudit', 'editAudit'].includes(this.$route.query.tab) ? this.$route.query.tab : 'list',
            data: null,
            dataList: null,
            datetimerange: isTab1Query ? [this.$route.query.startTime || '', this.$route.query.endTime || ''] : [],
            params: {
                ...defaultParams,
                pageNo: isTab1Query ? parseInt(this.$route.query.pageNo || 1) : 1,
                
                // pageSize 同样需守卫：避免审核 tab 的 URL 进入时每页条数污染 tab1
                pageSize: isTab1Query ? parseInt(this.$route.query.pageSize || this.$pageSizes[0]) : this.$pageSizes[0],
                searchType: isTab1Query ? parseInt(this.$route.query.searchType || 1) : 1,
                searchValue: isTab1Query ? (this.$route.query.searchValue || '') : '',
				status: isTab1Query ? parseInt(this.$route.query.status || -1) : -1,
				activitySource: isTab1Query ? parseInt(this.$route.query.activitySource || -1) : -1,
            },
            listLoading: true,
            downLoading: false,
            sswap: process.env.VUE_APP_SSWAP_URL,
			link:''
        };
    },
    watch: {
        
        // 切回 tab1 时若无数据则补拉（处理刷新直接进入审核 tab 后切回的场景）；若 URL 携带 tab1 筛选参数（带参链接进入后切 tab 刷新的场景）则先从 URL 实时恢复再拉取；query 带审核专属 auditStatus（审核详情返回）时跳过恢复避免参数混用
        activeName(val) {
            if (val != 'list' || this.data) return;
            const sp = new URLSearchParams(location.search);
            if (sp.get('auditStatus') == null) {
                const num = (k, dft) => {
                    const n = parseInt(sp.get(k));
                    return isNaN(n) ? dft : n;
                };
                this.params = {
                    ...this.params,
                    pageNo: num('pageNo', 1),
                    pageSize: num('pageSize', this.params.pageSize),
                    searchType: num('searchType', 1),
                    searchValue: sp.get('searchValue') || '',
                    status: num('status', -1),
                    activitySource: num('activitySource', -1)
                };
                this.datetimerange = [sp.get('startTime') || '', sp.get('endTime') || ''];
            }
            this.getDataList();
        }
    },
    mounted() {
        // 仅当前展示 tab1 时拉取列表数据（刷新恢复到审核 tab 时不发多余请求）
        if (this.activeName == 'list') {
            this.getDataList();
        }
    },
    methods: {
        
        // tab 切换：仅更新地址栏（history.replaceState 不触发路由导航，避免 query 变化导致组件销毁重建），保留现有 query 仅覆盖 tab，刷新后可恢复当前 tab 及筛选状态
        tabChange(tab) {
            const sp = new URLSearchParams(location.search);
            sp.set('tab', tab.name);
            window.history.replaceState(null, '', `${location.pathname}?${sp.toString()}`);
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/share/activity/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                        this.dataList.map(v => {
                            v.viewUrl = this.sswap + '/pages/special/share/detail/detail?activityId=' + v.id
                        })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //新增事件
        add() {
            this.$router.push({ path: "/promotion/shareActivity/add" });
        },
        //编辑事件
        edit(id) {
            this.$router.push({
                path: `/promotion/shareActivity/edit/${id}`,
                query: {
                    v: this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },

        //预览
        view(item) {			
			this.$request({
				url: "/share/activity/generateRedBookUrl",
				method: "POST",
				params: {
					id:item.id
				},
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1 && result) {
						this.link = result						
						this.$refs.codeView.show({
						    ...item,
						    name: item.title,
						    qrCodeUrl: item?.viewUrl,
						    Link:this.link,
							showWechart:0
						})					
						
					} else {
						this.$message.error(msg || "请求失败");
					}
				})
				.catch(() => {
					this.$message.error("请求错误");
				})
				.finally(() => {
					this.listLoading = false;
				});
        },
        //删除
        del(id) {
            const _msg = "确定要删除吗?删除后不可恢复";
            this.$confirm(_msg, "提示", {
                type: "warning",
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/share/activity/delete",
                    method: "POST",
                    params: { id: id },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.listLoading = false;
                    });
            });
        },
        //导出
        async download() {
            // const url = getHttp("/share/activity/export", { params: this.params });
            // this.$utils.downLoadReport(url);
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url: '/share/activity/export',
                method: 'post',
                params: { params: JSON.stringify(this.params) }
            })
                .catch(err => {
                    this.$message({ message: err.message, type: 'error' });
                })
            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            } else {
                return this.$message.error(msg || '下载失败');
            }

            await downloadFileTmp(filePath, '分享活动.xlsx');
            this.downLoading = false;
        },
        //参与用户
        user(id) {
            this.$router.push({
                path: `/promotion/shareActivity/joinedUser/${id}`,
                query: {
                    v: this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //标记是否完成发奖
        updateAwardFlag(row){
            this.listLoading = true;
            this.$request({
                url: "/share/activity/updateAwardFlag",
                method: "POST",
                params: { 
                    id: row.id , 
                    isEndAward: row.isEndAward
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.getDataList();
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        }
    },
};
</script>
